import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { DonateItem } from './views/DonateItem';

const Layout = new LayoutBuilder(() => <DonateItem />)
	.setDisplayName(Layouts.DonateItem)
	.setHudVisible(true)
	.build();

export default Layout;
